import {
    Autocomplete,
    Box,
    Button,
    FormControl,
    FormLabel,
    Table,
    Textarea,
    Typography
} from '@mui/joy';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { post, Token } from '../../../../../Script/Session';

function TarifStandFragenEditor() {
    const { id} = useParams();

    const [tarifid, settarifid] = useState();
    const [data, setdata] = useState();
    const [editmap, seteditmap] = useState(new Map());
    const [originalMap, setOriginalMap] = useState(new Map());
    const [fragenob, setfragenob] = useState();
    const navigate = useNavigate();
    const [bewertung, setbewertung] = React.useState(new Map());
  useEffect(() => {
    const key = `tarif-stand-edit-${id}`;
    const raw = localStorage.getItem(key);

    if (raw) {
      try {
        const parsed = JSON.parse(raw);
        setfragenob(parsed.fragen || []);
        settarifid(parsed.tarifId || null);

        // Optional: clean up after reading
        localStorage.removeItem(key);
      } catch (err) {
        console.error("Fehler beim Parsen:", err);
      }
    }
  }, [id]);
    useEffect(() => {
        let body = {
            token: Token.get(),
            action: "get",
            targetid: Number(id),
        };

        let response = post(body, "/tarife/tarifstand");
        if (response === "LOGOUT") {
            navigate("/");
            return;
        }

        const parsed = JSON.parse(response);
        setdata(parsed);

        const questionMap = new Map(
            parsed.questions.map(q => [q.question, q.antwort])
        );

        seteditmap(new Map(questionMap));
        setOriginalMap(new Map(questionMap));

        const bewertungsmap = new Map(
            parsed.bewertung.map(a => [a.question, a.bewertung])
        );
        setbewertung(bewertungsmap);
    }, []);

    function save() {
        let body = {
            token: Token.get(),
            targetid: Number(id),
            action: "editquestions",
            newq: Object.fromEntries(editmap),
            mewn: JSON.stringify(Array.from(bewertung.entries())),
            tarifid: Number(tarifid)
        };

        let response = post(body, "/tarife/tarifstand");
        if (response === "LOGOUT") {
            navigate("/");
        }
        if (response === "OK") {
            alert("Gespeichert!");
            window.open('', '_self');
            window.close();
        }
    }
    if (!data) {
        return (
            <Box sx={{ p: 2 }}>
                <Typography>Lade Tarifstand-Daten...</Typography>
            </Box>
        );
    }

    return (
        <Table sx={{ minHeight: "100vh", bgcolor: "white" }}>
            <thead>
                <tr>
                    <th>Frage</th>
                    <th>
                        <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                            <Typography>Antwort</Typography>
                            <Button onClick={save}>Speichern</Button>
                        </Box>
                    </th>
                </tr>
            </thead>
            <tbody>
                {Array.isArray(fragenob) &&
                    fragenob
                        .slice()
                        .sort((a, b) => a.order - b.order)
                        .map((item, index) => {
                            const keys = Object.keys(item).filter(k => k !== "order");
                            const name = keys[0] || "Unbenannt";

                            return (
                                <React.Fragment key={`${index}-${name}`}>
                                    <tr>
                                        <td colSpan={2} style={{ fontWeight: 'bold' }}>{name}</td>
                                    </tr>

                                    {Array.isArray(item[name]) &&
                                        item[name]
                                            .slice()
                                            .sort((a, b) => a.order - b.order)
                                            .map((frage, idx) => (
                                                <tr key={`${index}-${idx}`}>
                                                    <td>{frage.name}</td>
                                                    <td>
                                                        <Box sx={{ display: "flex", flexDirection: "column" }}>
                                                            <FormControl>
                                                                <FormLabel />
                                                                <Textarea
                                                                    value={editmap.get(frage.name) || ""}
                                                                    onChange={(e) => {
                                                                        const newMap = new Map(editmap);
                                                                        newMap.set(frage.name, e.target.value);
                                                                        seteditmap(newMap);
                                                                    }}
                                                                    minRows={5}
                                                                    style={{
                                                                        backgroundColor:
                                                                            originalMap.get(frage.name) !== editmap.get(frage.name)
                                                                                ? 'yellow'
                                                                                : 'white'
                                                                    }}
                                                                />
                                                            </FormControl>

                                                            <Autocomplete
                                                                options={frage.bewertung}
                                                                getOptionLabel={(i) => i.bzh}
                                                                value={
                                                                    frage.bewertung.find(
                                                                        (i) => i.id === bewertung.get(frage.name)
                                                                    ) ?? null
                                                                }
                                                                onChange={(e, newval) => {
                                                                    const newMap = new Map(bewertung);
                                                                    newMap.set(frage.name, newval?.id ?? null);
                                                                    setbewertung(newMap);
                                                                }}
                                                                sx={{
                                                                    bgcolor:
                                                                        data?.bewertung?.find((i) => i.question === frage.name)?.bewertung !== bewertung.get(frage.name)
                                                                            ? "yellow"
                                                                            : "white",
                                                                    mt: 1
                                                                }}
                                                            />
                                                        </Box>
                                                    </td>
                                                </tr>
                                            ))}
                                </React.Fragment>
                            );
                        })}
            </tbody>
        </Table>
    );
}

export default TarifStandFragenEditor;
